<template>
  <div class="modal is-modal-large" :class="{'is-active': active}">
    <div class="modal-background" @click.prevent.stop="close"></div>
    <div class="modal-card">
      <div class="row-width-actions-bar">
        <div class="columns is-gapless is-vcentered is-border-bottom">
          <div v-if='lre && lre.created_on' class="column is-narrow has-bg-success is-flex is-padding-small">
              <span class="icon has-text-white is-self-centered"><i class="fas fa-check-circle"></i></span>
          </div>
          <div v-else class="column is-narrow has-bg-danger is-flex is-padding-small">
              <span class="icon has-text-white is-self-centered"><i class="fas fa-clock"></i></span>
          </div>
          <div class="column is-padding-left is-self-centered">
            <span v-if='lre && lre.created_on' class="is-size-6 is-uppercase has-text-weight-medium">Recommandé (LRE) envoyé le {{lre.created_on|date}}</span>
            <span v-else class="is-size-6 is-uppercase has-text-weight-medium">Recommandé en attente</span>
            <span class="is-size-7">({{buyer.email}})</span>
          </div>
          <div class="column is-narrow is-border-left">
            <a class="page-header-btn is-small is-square" @click="close">
              <span class="icon is-size-4 has-text-dark"><i class="fal fa-times"></i></span>
            </a>
          </div>
        </div>
      </div>
      <section class="modal-card-body">
        <div class="is-multiline columns is-gapless has-bg-white is-min-height-50 is-border-top">
          <div class="column is-12 columns is-gapless is-padding-top-xlarge is-padding-bottom-xlarge">
            <div class="column is-narrow is-3"></div>
            <div class="column is-narrow is-size-5 is-size-6-widescreen is-size-4-fullhd">
              <i class="fal fa-5x fa-mail-bulk"></i>
            </div>
            <div v-if="lre" class="column is-6 is-narrow is-margin-left-large is-padding-top-xxsmall">
              <div class="title is-3 is-marginless  has-text-weight-medium">Courrier recommandé éléctronique (LRE)</div>
              <div><span class="is-size-7 has-text-success is-uppercase has-text-weight-medium">procédure LANCÉE LE {{lre.created_on | date}}</span></div>
              <div class="columns is-padding-top-small">
                <div class="column is-padding-top-xsmall is-padding-left-xsmall">
                  <ul class="steps is-xsmall steps--vertical-vad steps--separatorColorClassic-Vad">
                    <li class="step-item"
                      :class="sending ? 'is-success is-completed is-active' : ''"
                      data-step-id="0">
                      <div class="step-marker">
                        <span class="icon"><i class="fa fa-check"></i></span>
                      </div>
                      <div class="step-details">
                        <span class="has-text-weight-medium is-uppercase"
                          :class="sending ? '' : 'has-text-grey-light'">
                          En cours d’envoi
                        </span>
                      </div>
                    </li>
                    <li class="step-item"
                      :class="sent ? 'is-success is-completed is-active' : ''"
                      data-step-id="0">
                      <div class="step-marker">
                        <span class="icon"><i class="fa fa-check"></i></span>
                      </div>
                      <div class="step-details">
                        <span class="has-text-weight-medium is-uppercase"
                          :class="sent ? '' : 'has-text-grey-light'">
                          Envoyé <a :href="lre.proof" v-if="(lre.status === 'ev' || lre.status === 'dp') && lre.proof" class="is-underline">(preuve d'envoi)</a>
                        </span>
                      </div>
                    </li>
                    <li class="step-item"
                      :class="[lre.status === 'refused' || lre.status === 'bounced' ? 'is-danger is-completed is-active' : '', lre.status === 'ar' ? 'is-success is-completed is-active' : '']"
                      data-step-id="0">
                      <div class="step-marker">
                        <span  v-if="lre.status === 'refused' || lre.status === 'bounced'"
                          class="icon"><i class="fa fa-exclamation"></i></span>
                        <span  v-else
                          class="icon"><i class="fa fa-check"></i></span>
                      </div>
                      <div class="step-details">
                        <div class="has-text-weight-medium is-uppercase">
                          <span v-if="lre.status === 'refused'">
                            Refusée par le destinataire <a :href="lre.proof" v-if="lre.proof" class="is-underline">(preuve de refus)</a>
                          </span>
                          <span v-else-if="lre.status === 'bounced'">
                            Erreur lors de la Réception du lre
                          </span>
                          <span v-else :class="lre.status === 'ar' ? '' : 'has-text-grey-light'">
                            Réceptionné <a :href="lre.proof" v-if="lre.status === 'ar' && lre.proof" class="is-underline">(preuve de réception)</a>
                          </span>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
                <div v-if="lre.status === 'refused' || lre.status === 'bounced'" class="column is-7">
                  <button @click="sendLre" class="button is-small is-transform-none is-danger is-full">
                      <span v-if='!loadingLre' class="is-uppercase">relancer PROCÉDURE</span>
                      <span v-else><i class="fas fa-spinner fa-spin is-margin-xsmall"></i></span>
                    </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
  name: 'ProcedureModal',
  data () {
    return {
      loadingDelete: false,
      loadingLre: false,
      save: {
        numero_ar: false,
        sending_date: false,
        ar_received_date: false
      },
      courrier: {
        ar_received_date: null,
        numero_ar: null,
        sending_date: null
      },
      initCourrier: {},
      saveNum: false,
      saveSend: false,
      saveReceived: false,
      openProof: false,
      lreSent: false,
      envoiDemat: false,
      dateConfig: {
        altInput: true,
        altFormat: 'd/m/Y',
        dateFormat: 'Z'
      }
    }
  },
  filters: {
    date: function (value) {
      let date = moment(value).format('DD/MM/YYYY')
      let hour = moment(value).format('HH')
      let minute = moment(value).format('mm')

      return date + ' à ' + hour + 'h' + minute
    }
  },
  props: {
    params: Object,
    active: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    ...mapGetters(['isAdmin']),
    lre () {
      return this.params.lre
    },
    buyer () {
      return this.params.buyer
    },
    advPk () {
      return this.params.advPk
    },
    sending () {
      if (this.lre) {
        return this.lre.status === 'waiting' || this.lre.status === 'dp' ||
          this.lre.status === 'ev' || this.lre.status === 'ar' ||
          this.lre.status === 'refused' || this.lre.status === 'bounced'
      } else return false
    },
    sent () {
      if (this.lre) {
        return this.lre.status === 'dp' || this.lre.status === 'ev' ||
        this.lre.status === 'ar' || this.lre.status === 'refused' || this.lre.status === 'bounced'
      } else return false
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    openPreview () {
      let params = {
        idAdv: this.advPk,
        linkEmbed: this.lre.proof
      }
      this.$store.commit('setModal', { mode: 'DOCUMENT_PREVIEW', params })
    },
    async sendLRE (buyer) {
      this.loadingLre = true
      let request
      try {
        request = await this.$api.advService.postLre(this.procedure.adv, {
          buyer
        })
      } catch (e) {
        this.loadingLre = false
        console.log(request)
      } finally {
        this.loadingLre = false
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/modal/ProcedureModal.vue